import React, { useContext } from 'react';
import ConfirmModal from '../UI/Modal/confirmModal';
import { GlobalTemplateContext } from '../../contexts/GlobalTemplateContext';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const DeleteTemplateModal = ({ setSelectedAction, selectedTemplateId }) => {
    const { deleteTemplate, loading } = useContext(GlobalTemplateContext);
    const { content } = useContentfulContext();

    return (
        <ConfirmModal
            title={content.DELETE_TEMPLATE_MODAL_CONTENT.title}
            description={content.DELETE_TEMPLATE_MODAL_CONTENT.description}
            ConfirmText={content.DELETE_TEMPLATE_MODAL_CONTENT.delete_cta_text}
            loading={loading}
            hideModal={() => setSelectedAction('')}
            handleConfirmation={async () => {
                await deleteTemplate(selectedTemplateId);
                setSelectedAction('');
            }}
        />
    )
}

export default DeleteTemplateModal;